import React from 'react';
import { Link } from 'react-router';

const BookVisitSection = () => {
  return (
    <div className="relative min-h-[400px] w-full flex items-center justify-center">
      {/* Gradient background */}
      <div 
        className="absolute inset-0 bg-gradient-to-r from-cyan-200 via-yellow-100 to-cyan-200"
        style={{
          backgroundSize: '200% 200%',
          animation: 'gradient 15s ease infinite'
        }}
      />
      
      {/* Content overlay */}
      <div className="relative text-center max-w-3xl mx-auto px-4 py-16 space-y-6">
        <h2 className="text-4xl md:text-5xl font-serif text-gray-800">
          Book your visit online
        </h2>
        
        <p className="text-lg text-gray-700">
          View available appointments and enjoy dentistry done right. Get <span className="font-semibold text-teal-600">10% off all dental treatments</span>
        </p>
        
        <div className="pt-4">
          <Link
            to='/schedule-appointment' 
            className="bg-lime-400 text-gray-800 hover:bg-lime-500 transition-colors font-bold rounded px-8 py-3 duration-200"
            >
            BOOK ONLINE
          </Link>
        </div>
      </div>
      
      <style jsx>{`
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
};

export default BookVisitSection;